import React, { useImperativeHandle, useState, useRef, useEffect } from "react";
import { Popup, PopupRef, Position, ToolbarItem } from 'devextreme-react/popup';
import DataGrid, { Button, Column, DataGridRef, Editing, FilterRow, Form, Pager, Paging } from "devextreme-react/data-grid";
import 'devextreme-react/text-area';
import { useNavigate } from "react-router-dom";
import { useScreenSize } from "../../utils/media-query";
import PositionEditPanel from "./PositionEditPanel";

type Props = {
  readOnly?: boolean,
  onCoordinateChange?: (latitude?: number, longitude?: number) => void,
}

export type PositionEditPopupHandle = {
  edit: (latitude?: number, longitude?: number, address?:string) => void
}

type state = {
  operatoreId?: string,
  visible: boolean,
  latitude?: number,
  longitude?: number,
  address?: string,
}

const PositionEditPopup: React.ForwardRefRenderFunction<PositionEditPopupHandle, Props> = (props, ref) => {
  const [state, setState] = useState<state>({ operatoreId: undefined, visible: false, latitude: undefined, longitude: undefined });
  const [popupTitle, setPopupTitle] = useState<string>("Posizione");
  // const operatoreEditPanelRef = useRef<OperatoreEditPanelHandle>(null);

  function hide() {
    setState({ operatoreId: undefined, visible: false, latitude: undefined, longitude: undefined });
    // props.onHidden?.();
  }

  async function Confirm() {
    props.onCoordinateChange?.(state.latitude, state.longitude);
    hide(); 
  }

  useImperativeHandle(ref, () => ({
    edit(latitude, longitude, address) {
      setState({
        visible: true,
        latitude,
        longitude,
        address
      });
    }
  }));

  return (
    <React.Fragment>
      {state.visible &&
        <Popup
          visible={true}
          dragEnabled={false}
          hideOnOutsideClick={false}
          showCloseButton={true}
          fullScreen={true}
          showTitle={true}
          onHidden={hide}
          title={popupTitle}
          container=".dx-viewport"
        >
          <Position
            at="center"
            my="center"
            of=""
            collision="fit"
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={{
              text: 'Conferma',
              type: 'default',
              stylingMode: 'contained',
              onClick: Confirm
            }}
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={{
              text: 'Annulla',
              type: 'normal',
              stylingMode: 'contained',
              onClick: hide
            }}
          />

          <PositionEditPanel latitudine={state.latitude} longitudine={state.longitude} address={state.address} onCoordinateChange={(lat, lon) => {
              setState(prev => ({ ...prev, latitude: lat, longitude: lon })); 
          }} />
        </Popup>
      }
    </React.Fragment>
  );
}

export default React.forwardRef(PositionEditPopup);
